/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

import PicklistTrackingCreatedW from "./PICSTV1W/picklist-tracking-created";
import PicklistTrackingCreatedW1 from "./PICSTV1W1/picklist-tracking-created";
import PicklistTrackingOpenReleasedW from "./PICSTV2W/picklist-tracking-open-released";
import PicklistTrackingOpenReleasedW1 from "./PICSTV2W1/picklist-tracking-open-released";
import PicklistTrackingOpenReleasedW2 from "./PICSTV2W2/picklist-tracking-open-released";
import PicklistTrackingDeliveredW from "./PICSTV3W/picklist-tracking-delivered";

import GroupedPicklistTrackingW from "./PICSTV4W/grouped-picklist";
import GroupedPicklistTrackingW1 from "./PICSTV4W1/grouped-picklist";

const cookies = new Cookies();

const Picklist = ({ getSubModulesByRoleIdReducer, getSubModulesByRoleId }) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let PICSTV1WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "3ba2295c-4034-4fbf-b306-eee5e1c391b0",
  );

  let PICSTV1W1Access = modulesData.find((moduleId) => moduleId.moduleId == "");

  let PICSTV2WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "f043b85a-624a-4910-a25a-5024ac121433",
  );

  let PICSTV2W1Access = modulesData.find((moduleId) => moduleId.moduleId == "");

  let PICSTV2W2Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "68c564f3-c7f6-4229-8c37-00fd3a7ddda3",
  );

  let PICSTV3WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "5b2da9a6-fa19-4e0b-a38b-6868d94a2777",
  );

  let PICSTV4WAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "04d65980-1560-4cab-8958-2ab0dcd8d4ee",
  );

  let PICSTV4W1Access = modulesData.find(
    (moduleId) => moduleId.moduleId == "8453ab78-3436-4be7-b132-b08fecddaefc",
  );

  // Helper to render the correct GRN component based on access
  const getCreatedComponent = () => {
    if (PICSTV1W1Access) return <PicklistTrackingCreatedW1 />;

    if (PICSTV1WAccess) return <PicklistTrackingCreatedW />;
    return null;
  };

  // Helper to render the correct Printed GRN component based on access
  const getOpenReleasedComponent = () => {
    if (PICSTV2WAccess) return <PicklistTrackingOpenReleasedW />;
    if (PICSTV2W1Access) return <PicklistTrackingOpenReleasedW1 />;
    if (PICSTV2W2Access) return <PicklistTrackingOpenReleasedW2 />;
    return null;
  };

  const getGroupedComponent = () => {
    if (PICSTV4WAccess) return <GroupedPicklistTrackingW />;
    if (PICSTV4W1Access) return <GroupedPicklistTrackingW1 />;

    return null;
  };

  // Build tabs dynamically based on access
  const tabs = [];

  if (PICSTV1W1Access || PICSTV1WAccess) {
    tabs.push({
      header: "Picklist - Created",
      content: getCreatedComponent(),
    });
  }

  if (PICSTV3WAccess) {
    tabs.push({
      header: "Picklist - Delivered",
      content: <PicklistTrackingDeliveredW />,
    });
  }

  if (PICSTV2WAccess || PICSTV2W1Access || PICSTV2W2Access) {
    tabs.push({
      header: "Picklist - Open & Released",
      content: getOpenReleasedComponent(),
    });
  }

  if (PICSTV4WAccess || PICSTV4W1Access) {
    tabs.push({
      header: "Grouped By Picklist",
      content: getGroupedComponent(),
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {tabs.length > 0 ? (
              <TabView>
                {tabs.map((tab, idx) => (
                  <TabPanel key={idx} header={tab.header}>
                    {tab.content}
                  </TabPanel>
                ))}
              </TabView>
            ) : (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No PickList Access
              </h4>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Picklist);
